<template>
	<div class="member">
		<h2 v-if="flag == '1'" class="member-t">选择<span class="font-red">适合版本</span></h2>
		<p v-if="flag == '1'" class="member-p">年度购买基础版提供电子版，专业版加送视频教程，企业版额外附赠实体书籍，从新手到专家的全阶段学习资源。</p>
		<h2 v-if="flag == '2'" class="member-t">先体验再加盟</h2>
		<p v-if="flag == '2'" class="member-p">专业的寄存与回收业务管理工具，助力商户高效运营</p>
		<div class="member-img">
			<div class="member-img-item">
				<img class="top-img" src="../../static/home/top1-img.png" alt="" />
				<div class="top-tit">
					<div class="title saas-tit1">免费版</div>
					<div>免费体验、线上化办单全流程</div>
				</div>
				<div class="top-price">
					<div class="price">
						<span>¥</span>
						<span class="amount">0</span>
					</div>
					<div class="price-t">席位/月</div>
				</div>
				<div class="menber-btn menber-btn1" @click.stop="openCode()">免费使用</div>
				<div class="member-list">
					<div v-for="(item, i) in memberList1" :key="i" class="member-list-item">
						<div class="left">
							<img class="tick-img" src="../../static/home/tick1.png" alt="" />
							<span>{{ item.name }}</span>
						</div>
						<div class="right">{{ item.title }}</div>
					</div>
				</div>
			</div>
			<div class="member-img-item">
				<img class="top-img" src="../../static/home/top2-img.png" alt="" />
				<div class="top-tit">
					<div class="title saas-tit2">基础版<span class="title-tip">一年/9.5折</span></div>
					<div>资金安全、业务规范和风险控制</div>
				</div>
				<div class="top-price">
					<div class="price">
						<span>¥</span>
						<span class="amount">99</span>
					</div>
					<div class="price-t">席位/月</div>
				</div>
				<div class="menber-btn menber-btn2" @click.stop="openCode()">立即开通</div>
				<div class="member-list">
					<div class="member-list-item">
						<div class="left">
							<img class="tick-img" src="../../static/home/tick1.png" alt="" />
							<span class="font-color-tick1">包含免费版所有功能</span>
						</div>
					</div>
					<div v-for="(item, i) in memberList2" :key="i" class="member-list-item">
						<div class="left">
							<img class="tick-img" src="../../static/home/tick2.png" alt="" />
							<span>{{ item.name }}</span>
						</div>
						<div class="right">{{ item.title }}</div>
					</div>
				</div>
			</div>
			<div class="member-img-item">
				<img class="top-img" src="../../static/home/top3-img.png" alt="" />
				<div class="top-tit">
					<div class="title saas-tit3">专业版<span class="title-tip title-tip1">二年/9折</span></div>
					<div>团队管理、精细化运营提升业绩</div>
				</div>
				<div class="top-price">
					<div class="price">
						<span>¥</span>
						<span class="amount">158</span>
					</div>
					<div class="price-t">席位/月</div>
				</div>
				<div class="menber-btn menber-btn3" @click.stop="openCode()">立即开通</div>
				<div class="member-list">
					<div class="member-list-item">
						<div class="left">
							<img class="tick-img" src="../../static/home/tick2.png" alt="" />
							<span class="font-color-tick2">包含基础版所有功能</span>
						</div>
					</div>
					<div v-for="(item, i) in memberList3" :key="i" class="member-list-item">
						<div class="left">
							<img class="tick-img" src="../../static/home/tick3.png" alt="" />
							<span>{{ item.name }}</span>
						</div>
						<div class="right">{{ item.title }}</div>
					</div>
				</div>
			</div>
			<div class="member-img-item">
				<img class="top-img" src="../../static/home/top4-img.png" alt="" />
				<div class="top-tit">
					<div class="title saas-tit4">企业版<span class="title-tip title-tip2">三年/8.5折</span></div>
					<div>规模化、定制化和企业化运营</div>
				</div>
				<div class="top-price">
					<div class="price">
						<span>¥</span>
						<span class="amount">198</span>
					</div>
					<div class="price-t">席位/月</div>
				</div>
				<div class="menber-btn menber-btn4" @click.stop="openCode()">立即开通</div>
				<div class="member-list">
					<div class="member-list-item">
						<div class="left">
							<img class="tick-img" src="../../static/home/tick3.png" alt="" />
							<span class="font-color-tick3">包含专业版所有功能</span>
						</div>
					</div>
					<div v-for="(item, i) in memberList4" :key="i" class="member-list-item">
						<div class="left">
							<img class="tick-img" src="../../static/home/tick4.png" alt="" />
							<span>{{ item.name }}</span>
							<div class="service-fee" v-if="i == memberList4.length-1">(交易额超100万)</div>
						</div>
						<div class="right">{{ item.title }}</div>
					</div>
				</div>
			</div>
		</div>
		<ConsultDialog v-if="centerDialogVisible" @close="close"></ConsultDialog>
	</div>
</template>

<script>
	import ConsultDialog from './ConsultDialog.vue'
	export default {
		props: {
			flag: {
				type: String,
				default: '1'
			}
		},
		components: {ConsultDialog},
		data() {
			return {
				memberList1: [
					{name: '门店品牌加持', title: ''},
					{name: '估价系统', title: '1次/日'},
					{name: '合同立项', title: '5单/月'},
					{name: '订单管理', title: ''},
					{name: '财务审批', title: ''},
					{name: '智能计算器', title: ''},
					{name: '云铺商城', title: ''},
					{name: '订单资料云储存', title: ''},
					{name: '线上交易服务费1%', title: ''},
				],
				memberList2: [
					{name: '到期自动提醒服务', title: ''},
					{name: '逾期警示提醒服务', title: ''},
					{name: '销售时机提醒服务', title: ''},
					{name: '转回收业务提醒服务', title: ''},
					{name: '客户信用风险', title: ''},
					{name: '多端登录', title: ''},
					{name: '线上交易服务费1%', title: ''},
				],
				memberList3: [
					{name: '团队业绩报表', title: ''},
					{name: '综合资产管理', title: ''},
					{name: '智能仓库管理', title: ''},
					{name: '业绩排行榜', title: ''},
					{name: '物流追踪', title: ''},
					{name: '优惠券', title: ''},
					{name: '智能化获客代运营', title: ''},
					{name: '线上交易服务费1%', title: ''},
				],
				memberList4: [
					{name: '专业汽车业务系统服务', title: ''},
					{name: '全品类上游资源服务', title: ''},
					{name: '财务报表', title: ''},
					{name: '优质售后服务保障', title: ''},
					{name: '个性化模块定制服务', title: ''},
					{name: '产品业务培训', title: ''},
					{name: '智能匹配就近客户', title: ''},
					{name: '线上交易服务费0.6%', title: ''},
				],
				centerDialogVisible: false,
			}
		},
		methods: {
			close(flag) {
				this.centerDialogVisible = false
			},
			openCode() {
				this.centerDialogVisible = true
			},
		}
	}
</script>

<style scoped>
	.member {
		width: 1200px;
		margin: 0 auto;
		margin-top: 100px;
		/* margin-bottom: 15px; */
		padding-bottom: 70px;
	}
	.member-t {
		font-weight: 600;
		font-size: 40px;
		color: #333333;
		text-align: center;
	}
	.member-p {
		font-weight: 600;
		font-size: 14px;
		color: #999999;
		margin-bottom: 80px;
		text-align: center;
	}
	.member-img {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.member-img-item {
		width: 24%;
		height: 680px;
		background: #FFFFFF;
		border-radius: 15px;
		box-shadow: 0px 14px 27px 0px rgba(231,231,231,0.45);
	}
	.member-img-item .top-img {
		width: 100%;
		height: 10px;
		vertical-align: top;
	}
	.member-img-item .top-tit {
		font-weight: 600;
		font-size: 14px;
		color: #333333;
		padding: 0 30px;
		margin-top: 20px;
		margin-bottom: 20px;
	}
	.member-img-item .top-tit .title {
		font-size: 30px;
	}
	.member-img-item .top-tit .title .title-tip {
		font-size: 12px;
		color: #FFFFFF;
		margin-left: 6px;	
		height: 14px;
		background: #FFBD42;
		border-radius: 2px;
		padding: 1px 3px;
	}
	.member-img-item .top-tit .saas-tit1 {
		color: #3F575F;
	}
	.member-img-item .top-tit .saas-tit2 {
		color: #B25F05;
	}
	.member-img-item .top-tit .saas-tit3 {
		color: #9D3002;
	}
	.member-img-item .top-tit .saas-tit4 {
		color: #006CDF;
	}
	.title-tip1 {
		background: #1684FC !important;
	}
	.title-tip2 {
		background: #FE3D3A !important;
	}
	.member-img-item .top-price {
		display: flex;
		align-items: center;
		font-size: 16px;
		color: #333333;
		padding: 0 30px;
	}
	.member-img-item .top-price .price {
		flex: 1;
	}
	.member-img-item .top-price .price .amount {
		font-weight: 600;
		font-size: 40px;
	}
	.member-img-item .top-price .price-t {
		margin-top: 12px;
	}
	.menber-btn {
		height: 50px;
		line-height: 50px;
		border-radius: 30px;
		font-weight: 500;
		font-size: 20px;
		text-align: center;
		margin: 10px 20px 30px;
	}
	.menber-btn1 {
		color: #3F575F;
		border: 1px solid #3F575F;
	}
	.menber-btn2 {
		color: #333333;
		background: linear-gradient( 141deg, #FEEAC1 0%, #FFCA74 100%), #B25F05;
	}
	.menber-btn3 {
		color: #333333;
		background: linear-gradient( 141deg, #FBD7C1 0%, #F99864 100%);
	}
	.menber-btn4 {
		color: #333333;
		background: linear-gradient( 135deg, #D4EEFF 0%, #74C8FF 100%);
	}
	.member-img-item .member-list {
		padding: 0 30px 0px;
	}
	.member-img-item .member-list .member-list-item {
		display: flex;
		align-items: center;
		font-size: 14px;
		color: #333333;
		padding-bottom: 15px;
	}
	.member-list .member-list-item .left {
		flex: 1;
		font-weight: 600;
	}
	.member-list .member-list-item .right {
		font-weight: 400;
	}
	.member-list .member-list-item .tick-img {
		width: 13px;
		height: 10px;
		margin-right: 10px;
	}
	.font-color-tick1 {
		color: #3F575F;
	}
	.font-color-tick2 {
		color: #B25F05;
	}
	.font-color-tick3 {
		color: #9D3002;
	}
</style>


// WEBPACK FOOTER //
// src/components/Saas.vue